function resizeNav() {
    var newHeight = window.innerHeight;
    $('.header-mobile-content').css('max-height', newHeight );
}

$(document).ready(function() {
    window.dispatchEvent(new Event('resize'));
    
    resizeNav();
 
    $(window).on('resize', function () {
        resizeNav();
    });


    if ($('.typed').length) {
        var typer = $(".typed");
        var originalText = typer.html(); // Get the original HTML content
        var symbols = ['$', '<', '#', '@', '&', '?', '/', '+', '*', '%']; // List of random symbols
        var timeSpacing = 25; // Time between each character
        var isAnimating = false; // Flag, um festzustellen, ob die Animation läuft
        var animationTimeouts = []; // Array, um alle Timeout-IDs zu speichern


        function stopAnimation() {
            animationTimeouts.forEach(function(timeout) {
                clearTimeout(timeout);
            });
            animationTimeouts = [];
            isAnimating = false;

            // Sicherstellen, dass der ursprüngliche Text angezeigt wird
            typer.html(originalText);
        }
        
        // Function to get a random symbol
        function getRandomSymbol() {
            return symbols[Math.floor(Math.random() * symbols.length)];
        }
        
        // Function to animate each character with a symbol
        function animateText(text) {
            var currentText = "";
            var index = 0;
            isAnimating = true;

            // Filter-Buttons deaktivieren
            // $('.mixitup-control').addClass('disabled');

                // Funktion, um alle laufenden Animationen zu stoppen
           
        
            function animate() {
                if (index >= text.length) {
                    isAnimating = false;
    
                    // Filter-Buttons wieder aktivieren, sobald Animation beendet ist
                    $('.mixitup-control').removeClass('disabled');
                    return;
                }
        
                var char = text[index];
                var symbol = getRandomSymbol();
        
                // Display the symbol first
                currentText += symbol;
                typer.html(currentText);
        
                // After a short delay, replace the symbol with the actual character
                setTimeout(function() {
                    currentText = currentText.slice(0, -1) + char;
                    typer.html(currentText);
                    index++;
                    animate(); // Animate the next character
                }, timeSpacing);
            }
        
            animate(); // Start the animation
        }
        
        // Start the animation with the original text
        if (!isAnimating) {
            animateText(originalText);
        }

        // Eventlistener für Scrollen hinzufügen
        $(window).on('scroll', function() {
            var scrollPosition = $(this).scrollTop();
            var coverHeight = $('.cover__section').outerHeight(); // Höhe des Cover-Sections-Elements

            // Animation stoppen, wenn über die Höhe des Covers hinaus gescrollt wird
            if (scrollPosition > coverHeight) {
                stopAnimation();
            }
        });

        // // Eventlistener für Tab-Wechsel hinzufügen
        // document.addEventListener('visibilitychange', function() {
        //     if (document.visibilityState === 'visible') {
        //         // Überprüfen, ob Animation korrekt abgeschlossen ist
        //         if (isAnimating || typer.text() !== originalText) {
        //             stopAnimation(); // Animation stoppen
        //             // startAnimation(); // Animation neu starten
        //         }
        //     }
        // });

    }
    // if ($('.typed-home').length) {
    //     var typer = $(".typed-home");
    //     var text = typer.text().split("");
    //     var originalText = typer.text(); // Ursprünglicher Text
    //     typer.empty();
    //     var animationTimeouts = []; // Array, um alle Timeout-IDs zu speichern
    //     var isAnimating = false; // Flag, ob die Animation läuft


    //     // Funktion, um alle laufenden Animationen zu stoppen
    // function stopAnimation() {
    //     animationTimeouts.forEach(function(timeout) {
    //         clearTimeout(timeout);
    //     });
    //     animationTimeouts = [];
    //     isAnimating = false;

    //     // Sicherstellen, dass der ursprüngliche Text angezeigt wird
    //     typer.html(originalText);
    // }

    //     var symbols = ['$', '<', '#', '@', '&', '?', '/', '+', '*', '%']; // List of random symbols
    //     var timeSpacing = 25; // Time between each character

    //     // Function to get a random symbol
    //     function getRandomSymbol() {
    //         return symbols[Math.floor(Math.random() * symbols.length)];
    //     }

    //     // Start the animation after 2 seconds
    //     setTimeout(function() {
    //         var currentText = ""; // To store the progressively animated content

    //         text.forEach(function(el, index) {
    //             setTimeout(function() {
    //                 if (index % 2 === 1) { // Apply random symbol for every second letter
    //                     var symbol = getRandomSymbol(); // Get a random symbol
    //                     currentText += symbol; // Add the random symbol
    //                     typer.text(currentText); // Update the text with the symbol
                        
    //                     // Replace the symbol with the actual character after a delay
    //                     setTimeout(function() {
    //                         currentText = currentText.slice(0, -1) + el; // Replace symbol with actual letter
    //                         typer.text(currentText); // Update the text with the actual letter
    //                     }, timeSpacing);
    //                 } else {
    //                     // Directly add the letter if it's not every second letter
    //                     currentText += el;
    //                     typer.text(currentText); // Update the text with the letter
    //                 }
    //             }, index * timeSpacing * 2); // Adjust timing to fit the delay for both symbol and letter
    //         });
    //     }, 2000);

    //     // Eventlistener für Scrollen hinzufügen
    //     $(window).on('scroll', function() {
    //         var scrollPosition = $(this).scrollTop();
    //         var coverHeight = $('.cover__section').outerHeight(); // Höhe des Cover-Sections-Elements

    //         // Animation stoppen, wenn über die Höhe des Covers hinaus gescrollt wird
    //         if (scrollPosition > coverHeight) {
    //             stopAnimation();
    //         }
    //     });
    // }


    if ($('.typed-home').length) {
        var typer = $(".typed-home");
        var text = typer.text().split("");
        var originalText = typer.text(); // Ursprünglicher Text
        typer.empty();
        var animationTimeouts = []; // Array, um alle Timeout-IDs zu speichern
        var isAnimating = false; // Flag, ob die Animation läuft
    
        // Funktion, um alle laufenden Animationen zu stoppen
        function stopAnimation() {
            animationTimeouts.forEach(function(timeout) {
                clearTimeout(timeout);
            });
            animationTimeouts = [];
            isAnimating = false;
    
            // Sicherstellen, dass der ursprüngliche Text angezeigt wird
            typer.html(originalText);
        }
    
        var symbols = ['$', '<', '#', '@', '&', '?', '/', '+', '*', '%']; // Liste zufälliger Symbole
        var timeSpacing = 25; // Zeit zwischen jedem Zeichen
    
        // Funktion, um ein zufälliges Symbol zu erhalten
        function getRandomSymbol() {
            return symbols[Math.floor(Math.random() * symbols.length)];
        }
    
        // Animation starten
        function startAnimation() {
            var currentText = ""; // Um den progressiv animierten Text zu speichern
            isAnimating = true;
    
            text.forEach(function(el, index) {
                var symbolTimeout = setTimeout(function() {
                    if (index % 2 === 1) { // Zufälliges Symbol für jedes zweite Zeichen
                        var symbol = getRandomSymbol(); // Zufälliges Symbol holen
                        currentText += symbol; // Symbol hinzufügen
                        typer.text(currentText); // Text aktualisieren
    
                        // Symbol nach kurzer Verzögerung durch den Buchstaben ersetzen
                        var letterTimeout = setTimeout(function() {
                            currentText = currentText.slice(0, -1) + el; // Symbol durch Buchstaben ersetzen
                            typer.text(currentText); // Text aktualisieren
                        }, timeSpacing);
    
                        animationTimeouts.push(letterTimeout); // Timeout speichern
                    } else {
                        // Direkt den Buchstaben hinzufügen, wenn es nicht jedes zweite Zeichen ist
                        currentText += el;
                        typer.text(currentText); // Text aktualisieren
                    }
                }, index * timeSpacing * 2); // Timing für Symbol und Buchstabe anpassen
    
                animationTimeouts.push(symbolTimeout); // Timeout speichern
            });
        }
    
        // Animation nach 2 Sekunden starten
        setTimeout(startAnimation, 2000);
    
        // Eventlistener für Scrollen hinzufügen
        $(window).on('scroll', function() {
            var scrollPosition = $(this).scrollTop();
            var coverHeight = $('.cover__section').outerHeight(); // Höhe des Cover-Sections-Elements
    
            // Animation stoppen, wenn über die Höhe des Covers hinaus gescrollt wird
            if (scrollPosition > coverHeight) {
                stopAnimation();
            }
        });

        // Eventlistener für Tab-Wechsel hinzufügen
        document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'visible') {
                // Überprüfen, ob Animation korrekt abgeschlossen ist
                if (isAnimating || typer.text() !== originalText) {
                    stopAnimation(); // Animation stoppen
                    // startAnimation(); // Animation neu starten
                }
            }
        });
    }
    


    // // add random class to body
    // var classes = ['site--purple','site--pink', 'site--orange', 'site--green', 'site--turkis', 'site--blue']; //add as many classes as u want
    // var randomnumber = Math.floor(Math.random()*classes.length);
    // $('body').addClass(classes[randomnumber]);

        // add random class to body by session
        // $(document).ready(function() {
            var classes = ['site--purple','site--pink', 'site--orange', 'site--green', 'site--turkis', 'site--blue'];
            // Check if a class is already stored in sessionStorage
            var savedClass = sessionStorage.getItem('randomClass');
        
            if (savedClass) {
                // If a class is already stored, apply it to the body
                $('body').addClass(savedClass);
            } else {
                // If no class is stored, generate a random one
                var randomnumber = Math.floor(Math.random() * classes.length);
                var randomClass = classes[randomnumber];
        
                // Add the random class to the body
                $('body').addClass(randomClass);
        
                // Store the selected class in sessionStorage
                sessionStorage.setItem('randomClass', randomClass);
            }
        // });

    
    
    //home change header color on scroll
    // $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 100) {
    //         $(".home .site-header").addClass('bg-white').removeClass('bg-none');
    //     } else {
    //         $(".home .site-header").removeClass('bg-white').addClass('bg-none');
    //     }
    // })


    //dropdown function
    $('.menu-top .menu-item-has-children').each(function() {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function() {
        $(this).click(function(e) {
            e.preventDefault();

            $(".dropdown-link").next().not($(this).next()).removeClass('dropdown');
            $(".dropdown-link").next().not($(this).next()).slideUp();
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
                $(this).next().slideUp();
            } else {
                $(this).next().addClass('dropdown');
                $(this).next().slideDown();
            }
        });
    })
    // //close dropdown if click on page
    $(document).mouseup(function(e) {
        var container = $(".sub-menu, .dropdown-link");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".dropdown-link").next().removeClass('dropdown');
            $(".dropdown-link").next().slideUp();
        }
    });


    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).addClass('acc-submenu');
    });
    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).children('a').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('rotate');
            $(this).next().toggleClass('acc--menu--open');
            $(this).next().slideToggle('slow');
        });
    });




    $('.burger--menu--toggle').click(function() {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass("header--open")) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass("burger--closed");
            $('body').addClass('nav--open');


            //open menu
            $('.header-mobile-content').addClass("header--open").removeClass("header--closed");
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass("burger--closed");
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
            $('html, body').css({
                overflow: 'visible',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }

        setTimeout(function() {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay

    });



    // //close menu if click on page
    $(document).mouseup(function(e) {
        var container = $(".header--open, .header--burger");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass("header--open");
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }
    });



    // //hide navbar on scroll
    $(function() {
        var lastScrollTop = 0,
            delta = 5;
        $(window).scroll(function() {
            var nowScrollTop = $(this).scrollTop();
            var scroll = $(window).scrollTop();

            if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
                if (nowScrollTop > lastScrollTop) {
                    // SCROLLING DOWN
                    if (scroll >= 600) {
                        $('.site-header').removeClass('nav-down').addClass('nav-up');
                    }
                } else {
                    // SCROLLING UP
                    $('.site-header').removeClass('nav-up').addClass('nav-down');
                }
                lastScrollTop = nowScrollTop;
            }
        });
    });
});
